import {Component, OnDestroy, OnInit} from '@angular/core';
import {ApiClientService} from 'app/services/api-client.service';
import {Router} from '@angular/router';
import {DirectoryService} from 'app/services/directory.service';
import {UrlService} from 'app/services/url.service';
import {Subject} from 'rxjs/Subject';
import {debounceTime, distinctUntilChanged, flatMap, map, takeUntil, tap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';

declare const $: any;

@Component({
    selector: 'quick-search',
    templateUrl: './quick-search.component.html',
    styleUrls: ['./quick-search.component.scss']
})
export class QuickSearchComponent implements OnInit, OnDestroy {
    searchString: string = '';
    listOfUsers: any[] = [];
    noMatches: boolean;

    searchStringChanged = new Subject<string>();
    $destroy = new Subject<void>();

    constructor(
        private api: ApiClientService,
        private router: Router,
        private directoryService: DirectoryService,
        private urlService: UrlService
    ) {
        this.searchStringChanged
            .pipe(
                distinctUntilChanged(),
                debounceTime(500),
                flatMap(() => this.search().pipe(takeUntil(this.searchStringChanged))),
                takeUntil(this.$destroy)
            )
            .subscribe();
    }

    ngOnInit(): void {
        this.clearSearch();
    }

    searchOnInput() {
        this.listOfUsers = [];
        this.searchStringChanged.next(this.searchString);
    }

    search() {
        if (this.searchString === '') {
            this.listOfUsers = [];
            return of([]);
        }

        const url = `/v1/suite-users.json?expand=user,user.phones,user.addresses,user.groups.group,suite,building&per-page=15&query=:suite.suiteNumber|user.fullName:*${this.searchString}*`;
        return this.api.getJson('domainBD', `${url}`)
            .pipe(
                map(r => r.entities),
                tap(
                    (response) => {
                        this.listOfUsers = response;
                        this.noMatches = !this.listOfUsers.length;
                    },
                    (error) => {
                        console.log(error);
                    }
                )
            );
    }

    viewResident(item) {
        this.urlService.resetQueryParams();
        const user = [];
        user.push(item);

        const resident = this.directoryService.residentFactory(user);
        resident[0].checked = true;
        UrlService.EnableResetQueryParams = false;

        this.router.navigate(['/directory'], {
            queryParams: {
                tab: 'residents'
            },
           // queryParamsHandling: 'merge',
        }).then(() => {
            UrlService.EnableResetQueryParams = true;
            // this.directoryService.quickSearchStore = {
            //     resident: resident[0],
            //     residentName: item.user.fullName
            // };
           setTimeout(() => {
               this.directoryService.quickSearchStore$.next({
                   resident: resident[0],
                   residentName: item.user.fullName
               });
           }, 100);
        });

        this.clearSearch();
    }

    navigateByArrows(e) {
        const $filter = $('.filter-list');
        const $listItems = $filter.find('.filter-list-item');
        const $active = $('.filter-list-item.active');
        if (!$listItems.length) return;

        let index = $listItems.hasClass('active') ? $listItems.index($active[0]) : -1;
        index = (index === $listItems.length - 1) ? -1 : index;

        if (e.keyCode === 38) {
            $listItems.eq(index - 1).addClass('active');
            $listItems.eq(index - 1).find('a').focus();
            if ($listItems[index - 1]) $listItems[index - 1].scrollIntoView();
        }

        if (e.keyCode === 40) {
            $listItems.eq(index + 1).addClass('active');
            $listItems.eq(index + 1).find('a').focus();
            if ($listItems[index + 1]) $listItems[index + 1].scrollIntoView();
        }

        if (e.keyCode === 13) {
            if (!$active.length) return;
            setTimeout(() => {
                if (index === -1) {
                    $listItems[0].click();
                } else {
                    $listItems[index].click();
                }
            }, 50);
        }

        if ($listItems.length > 1) $listItems.eq(index).removeClass('active');
    }

    clearSearch() {
        this.searchString = '';
    }

    ngOnDestroy(): void {
        this.$destroy.next();
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/quick-search/quick-search.component.ts